import { ObjectType, Field, InputType, Int, ID } from 'type-graphql'

import { ObjectRef, ScalarObject } from '@things-factory/shell'

import { PagePreference } from './page-preference'

@InputType()
export class NewPagePreference {
  @Field(type => ObjectRef)
  user: ObjectRef

  @Field({ nullable: true })
  page?: string

  @Field({ nullable: true })
  element?: string

  @Field(type => ScalarObject, { nullable: false })
  preference: { [key: string]: any }
}

@InputType()
export class PagePreferencePatch {
  @Field(type => ID, { nullable: true })
  id?: string

  @Field(type => ObjectRef)
  user: ObjectRef

  @Field({ nullable: true })
  page?: string

  @Field({ nullable: true })
  element?: string

  @Field(type => ScalarObject, { nullable: false })
  preference: { [key: string]: any }

  @Field()
  cuFlag: string
}

@ObjectType()
export class PagePreferenceList {
  @Field(type => [PagePreference])
  items: PagePreference[]

  @Field(type => Int)
  total: number
}
